export default "__VITE_ASSET__CYRpEoBn__"